module.exports = __webpack_public_path__ + "img/product-6-glu.1012bff0.png";